<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Agents'"
    [canGoBack]="true"
    [customBack]="'more'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<tidy-unified-agent
  [mobileView]="'triggers'"
  (triggerSelected)="onTriggerSelected($event)" />
